
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/playground.zh-CN.md?watch=parent';
    export const toc = [{"id":"docs-x-markdown-playground-demo-playground","depth":3,"title":"XMarkdown 在线体验"}];
export const frontmatter = {"title":"在线体验","toc":"menu","filename":"docs/x-markdown/playground.zh-CN.md","lastUpdated":1775443983000,"order":2.1,"__autoDescription":true};